import type { ReactNode } from 'react';

interface DrawerScrollPanelProps {
  children: ReactNode;
}

/**
 * Vertical scroll container for drawer tab content.
 *
 * MUST be the last child of a `flex flex-col` parent — `flex-1` claims
 * remaining space, `min-h-0` lets it shrink so its own `overflow-y-auto`
 * engages instead of letting content escape into the outer Drawer scroll.
 */
export function DrawerScrollPanel({ children }: DrawerScrollPanelProps) {
  return (
    <div
      className="min-h-0 flex-1 overflow-x-hidden overflow-y-auto"
      data-testid="drawer-scroll-panel"
    >
      {children}
    </div>
  );
}
